/* HDE page styles - converted from archipro2 SCSS */
/* Background color matches archipro2 $mgeBlack: #171616 */

/* TODO: Add flickity CSS when implementing gallery slider
   Install: pnpm add flickity react-flickity-component
   Import: @import 'flickity/css/flickity.css';
*/

body.page-mge {
    background: #171616;
}

/* Scrollbar styling matching archipro2 theme */
.scrollbar-archipro {
    scrollbar-width: thin;
    scrollbar-color: #bea78c transparent;
}

/*
 * Allow vertical page scrolling to continue when a finger starts on a
 * horizontally scrollable HDE track.
 */
.hde-mobile-carousel {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    touch-action: pan-x pan-y pinch-zoom;
}

.scrollbar-archipro::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}

.scrollbar-archipro::-webkit-scrollbar-track {
    background-color: transparent;
}

.scrollbar-archipro::-webkit-scrollbar-track:hover {
    background: none;
}

.scrollbar-archipro::-webkit-scrollbar-thumb {
    background: #bea78c;
    border-radius: 100px;
    background-clip: padding-box;
}

.scrollbar-archipro::-webkit-scrollbar-thumb:hover {
    background: #bea78c;
}

.scrollbar-archipro::-webkit-scrollbar-thumb:active {
    background: #bea78c;
}

/* Global scrollbar styling for HDE pages */
/* Target both html and body since the main viewport scrollbar can be on either */
html.page-mge,
body.page-mge {
    scrollbar-width: thin;
    scrollbar-color: #bea78c transparent;
}

html.page-mge::-webkit-scrollbar,
body.page-mge::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}

html.page-mge::-webkit-scrollbar-track,
body.page-mge::-webkit-scrollbar-track {
    background-color: transparent;
}

html.page-mge::-webkit-scrollbar-thumb,
body.page-mge::-webkit-scrollbar-thumb {
    background: #bea78c;
    border-radius: 100px;
}

html.page-mge::-webkit-scrollbar-thumb:hover,
body.page-mge::-webkit-scrollbar-thumb:hover {
    background: #bea78c;
}

body.page-mge.page-mge-2021 {
    /* Mobile margin adjustments */
}

@media (max-width: 414px) {
    body.page-mge {
        margin-right: 0 !important;
    }

    body.page-mge.page-mge-2021 .directoryWrap {
        padding-top: 0;
        min-height: unset !important;
    }

    body.page-mge.page-mge-2021 .directoryWrap > div:not(:empty) {
        min-height: 126vw !important;
    }
}

@keyframes hde-clip-reveal {
    from {
        clip-path: inset(0 100% 0 0);
    }
    to {
        clip-path: inset(0 0 0 0);
    }
}

@keyframes hde-line-draw {
    from {
        transform: scaleX(0);
    }
    to {
        transform: scaleX(1);
    }
}

@keyframes hde-arrow-pulse {
    0% {
        transform: translateX(0);
    }
    40% {
        transform: translateX(4px);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes hde-scale-settle {
    from {
        transform: scale(1.08);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

.hde-clip-reveal {
    animation: hde-clip-reveal 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.hde-line-draw {
    transform-origin: left;
    animation: hde-line-draw 0.5s ease-out both;
}

.hde-arrow-pulse {
    animation: hde-arrow-pulse 2.5s ease-in-out infinite;
}

.group:hover .hde-register-arrow {
    animation-play-state: paused;
}

.hde-scale-settle {
    animation: hde-scale-settle 0.8s cubic-bezier(0.16, 1, 0.3, 1) both;
}
